import { Component, Input } from '@angular/core';

@Component({
  selector: 'ti-card',
  standalone: true,
  imports: [],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class CardComponent {
  @Input()
  public appearance: 'default' | 'slim' = 'default';
}
